import { render, staticRenderFns } from "./generic-banner.vue?vue&type=template&id=7651d63c"
import script from "./generic-banner.vue?vue&type=script&lang=js"
export * from "./generic-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports